module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-block",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyContent)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7160c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Text.vue
// module id = 78
// module chunks = 0